"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorderColorFromVariant = exports.getBackgroundColorFromVariant = exports.getColorFromVariant = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
/**
 * Returns the color based on the variant and props.
 *
 * @param {string} color - The color variant.
 * @param {object} props - The component props.
 * @returns {string} The color value.
 */
const getColorFromVariant = (color, props) => {
    const foreground = (0, ui_theme_1.fromTheme)('color_text_contrast')(props);
    const background = (0, exports.getBackgroundColorFromVariant)(color, props);
    return (0, ui_theme_1.checkColorContrast)(foreground, background)
        ? foreground
        : (0, ui_theme_1.fromTheme)('color_text')(props);
};
exports.getColorFromVariant = getColorFromVariant;
/**
 * Retrieves the background color based on the provided variant color.
 *
 * @param {string} color - The variant color.
 * @param {object} props - The props object.
 * @returns {string} - The background color.
 */
const getBackgroundColorFromVariant = (color, props) => {
    let bgColor;
    if (color !== 'default') {
        bgColor = (0, ui_theme_1.fromTheme)(`color_${color}`)(props);
    }
    return bgColor || (0, ui_theme_1.fromTheme)('color_background_badge')(props);
};
exports.getBackgroundColorFromVariant = getBackgroundColorFromVariant;
/**
 * Returns the border color based on the variant color.
 *
 * @param {string} color - The variant color.
 * @param {object} props - The component props.
 * @returns {string} The border color.
 */
const getBorderColorFromVariant = (color, props) => {
    let borderColor;
    if (color !== 'default') {
        borderColor = (0, ui_theme_1.fromTheme)(`color_${color}`)(props);
    }
    return borderColor || (0, ui_theme_1.fromTheme)('color_background_badge')(props);
};
exports.getBorderColorFromVariant = getBorderColorFromVariant;
//# sourceMappingURL=badges.js.map